<template>
  <div>
    <v-card class="d-flex flex-row pa-2" color="accent" elevation="2" outlined>
      <v-row align="center" class="pa-2">
        <div class="text-h5 primary--text font-weight-bold mr-auto">
          {{ nomeBloco }}
        </div>

        <v-btn
          class="button-card text-capitalize"
          color="primary"
          dark
          :to="{ name: 'editarBloco', params: { id: id } }">
          Editar Bloco
        </v-btn>

        <v-btn
          icon
          large
          color="red"
          class="text--darken-4"
          dark
          @click.prevent="dialogDelete = true">
          <v-icon>mdi-delete-circle</v-icon>
        </v-btn>
      </v-row>
    </v-card>
    <v-delete-bloco-dialog
      :visivel="dialogDelete"
      @close="dialogDelete = false"
      @confirma="$emit('delete', id), (dialogDelete = false)" />
  </div>
</template>

<script>
import VDeleteBlocoDialog from "@/components/dialogs/bloco/VDeleteBlocoDialog"

export default {
  name: "VCardBloco",

  components: { VDeleteBlocoDialog },

  props: {
    nomeBloco: {
      type: String,
    },
    id: {
      type: Number,
    },
  },
  data() {
    return {
      dialogDelete: false,
    }
  },
}
</script>
